export default __webpack_public_path__ + "static/media/trending_up.7a236a09.svg";